import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  FormFieldSet,
  Modal,
  PageHeader,
  PageTitle,
  showToast,
  useFormHandler,
} from "../../../../../../components";
import {
  federalFilingStatus,
  suiState,
  w4Form,
} from "../../../../../../assets/data/projectData";
import {
  RecordStatus,
  TimesheetCycles,
} from "../../../../../../assets/data/enumData";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import { useDispatch, useSelector } from "react-redux";
import { updateEmployeeStart } from "../../../../../../redux/slices/employee/employeeSlice";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import { v4 as uuidv4 } from "uuid";
import { uploadStart } from "../../../../../../redux/slices/universal/fileUploadSlice";
import {
  addW4FormDocumentsStart,
  getAllTaxFormDocumentsStart,
  // updateW4FormDocumentsStart  // omkar commented this vite issue
} from "../../../../../../redux/slices/document/documentSlice";
import { addDocumentStart } from "../../../../../../redux/slices/universal/documentsSlice";
const W4FormModal = ({ isOpen, onClose, edit }) => {
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
  } = useSelector((state) => state.employee);
  const { userData: loginUserData } = useLoginUser();
  const organizationId = loginUserData?.organizationId.uiid;
  const loginUserUiid = loginUserData?.uiid;
  const dispatch = useDispatch();
  const [validationRules, setValidationRules] = useState({});
  const initialFormData = {
    whichW4FormDoYouHave: "",
    title: "",
    dateOfJoining: "",
    federalFilingStatus: "",
    payFrequency: "",
    suiState: "",
    payrollWhState: "",
    multipleJobs: [],
    claimDependent: "",
    effectiveDate: "",
    status: "",
    otherIncomeAmount: "",
    deductionsAmount: "",
    extraWithholdingAmount: "",
    exemptFromwithholding: [],
    employeeExemptFromFederalTaxes: [],
    attachments: [],
    notes: "",
    // attachments: [
    //   {
    //     id: uuidv4(),
    //     attachmentName: "",
    //     attachmentComments: "",
    //     chooseFiles: [],
    //   },
    // ],
  };

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);

  useEffect(() => {
    const baseRules = {
      whichW4FormDoYouHave: { type: "text", required: true },
      federalFilingStatus: { type: "text", number: true },
      payFrequency: { type: "text", number: true },
      status: { type: "text", number: true },
      attachments: { type: "file", required: true },
      // dateOfJoining: { type: "date", required: true },
      // payFrequency: { type: "select", required: true },
      // attachments: {
      //   type: "file",
      //   required: true,
      //   allowedFiles: [
      //     { ext: "png", mime: "image/png" },
      //     { ext: "txt", mime: "text/plain" },
      //   ],
      // },
    };
    setValidationRules(baseRules);
  }, [formData.attachments.length]);
  const handleSaveW4Form = () => {
    const isValid = validateAllFields();
    if (!isValid) {
      showToast("Please fill all the required fields before saving", "error");
      return;
    }
    // Build form data
    const userFormData = {
      addedBy: loginUserUiid,
      employeeId: employeeProfileUiid,
      formType: formData.whichW4FormDoYouHave,
      title: formData.title,
      doj: formData.dateOfJoining,
      federalFilingStatus: formData.federalFilingStatus,
      payFrequency: formData.payFrequency,
      state: {
        sui: formData.suiState,
        payrollWh: formData.payrollWhState,
      },
      multipleJobs: formData.multipleJobs ? true : false,
      dependentClaimNCredits: formData.claimDependent,
      effectiveDate: formData.effectiveDate,
      status: formData.status,
      otherIncAmt: formData.otherIncomeAmount,
      deductAmt: formData.deductionsAmount,
      extraWithholdAmt: formData.extraWithholdingAmount,
      exemptFromWithhold: formData.exemptFromwithholding ? true : false,
      isExemptFromFederalTax: formData.employeeExemptFromFederalTaxes
        ? true
        : false,
      notes: formData.notes,
      taxType: 1,
    };

    const submissionData = filterEmptyValues(userFormData);

    // Prepare attachments with UUID
    const cleanAttachments = Array.isArray(formData.attachments)
      ? formData.attachments.map((file) => {
          file.id = uuidv4();
          return file;
        })
      : [];
    console.log("cleanAttachments", cleanAttachments);
    // If there are attachments, handle upload first
    if (cleanAttachments.length > 0) {
      dispatch(
        uploadStart({
          uploadType: "multiple",
          field: "doc",
          uiid: employeeProfileUiid,
          entity: "emptaxforms",
          category: "w4form",
          coll: "EmpTaxform",
          doc: cleanAttachments,
          onSuccess: async (fileData) => {
            dispatch(
              addW4FormDocumentsStart({
                coll: "EmpTaxform",
                payload: submissionData,
                onSuccess: async (response) => {
                  const taxFormId = response?.data?.data?.taxformId;
                  if (!taxFormId) return;
                  dispatch(
                    addDocumentStart({
                      coll: "Document",
                      refColl: "EmpTaxform",
                      refId: taxFormId,
                      refField: "documents",
                      payload: {
                        addedBy: loginUserUiid,
                        attachments: [
                          {
                            parent: { employee: employeeProfileUiid },
                            addedBy: loginUserUiid,
                            docType: "W4Form",
                            ref: {
                              id: taxFormId,
                              entity: "documents",
                              path: `documents`,
                            },
                            file: cleanAttachments.map((obj) => ({
                              name: obj.attachmentName,
                              comments: obj.attachmentComments,
                              keys: fileData
                                .filter(
                                  (file) =>
                                    file?.fileRefId === obj.id && file.key,
                                )
                                .map((file) => file.key),
                            })),
                          },
                        ],
                      },
                      onSuccess: async () => {
                        onClose();
                        dispatch(
                          getAllTaxFormDocumentsStart({
                            tab: "w4FormTab",
                            ret: "w4Form",
                            coll: "EmpTaxform",
                            fil: {
                              employeeId: {
                                type: "NONE",
                                value: employeeProfileUiid,
                              },
                              taxType: {
                                type: "NONE",
                                value: 1,
                              },
                            },
                            ref: "Document",
                          }),
                        );
                      },
                    }),
                  );
                },
              }),
            );
          },
        }),
      );
    }
  };

  const handleModalClose = () => {
    onClose(true);
    setFormData(initialFormData);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleModalClose}
      title="ADD  W-4 FORM"
      width="max-w-7xl"
    >
      {/* <div className="grid grid-cols-3 gap-x-6 gap-y-6"> */}
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-4">
        <div>
          <FormFieldSet
            type="select"
            title="Which W-4 Form do you have:"
            placeholder="Select Which W-4 Form do you have"
            value={formData.whichW4FormDoYouHave}
            onChange={(value) => handleChange("whichW4FormDoYouHave", value)}
            error={errors.whichW4FormDoYouHave}
            options={w4Form}
          />
        </div>
        <div>
          <FormFieldSet
            type="text"
            title="Title"
            placeholder="Enter Title"
            value={formData.title}
            onChange={(value) => handleChange("title", value)}
            error={errors.title}
          />
        </div>
        <div className="hidden lg:block" />
        <div>
          <FormFieldSet
            type="datepicker"
            title="Date of Joining"
            placeholder="Select Date of Joining"
            value={formData.dateOfJoining}
            onChange={(value) => handleChange("dateOfJoining", value)}
            error={errors.dateOfJoining}
            showDropdown={false}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            title="Federal Filing Status"
            placeholder="Select Federal Filing Status"
            value={formData.federalFilingStatus}
            onChange={(value) => handleChange("federalFilingStatus", value)}
            error={errors.federalFilingStatus}
            options={federalFilingStatus}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            title="Pay Frequency"
            placeholder="Select Pay Frequency"
            value={formData.payFrequency}
            onChange={(value) => handleChange("payFrequency", value)}
            error={errors.payFrequency}
            options={TimesheetCycles}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            title="SUI State"
            placeholder="Select SUI State"
            value={formData.suiState}
            onChange={(value) => handleChange("suiState", value)}
            error={errors.suiState}
            options={suiState}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            title="Payroll WH State"
            placeholder="Select Payroll WH State"
            value={formData.payrollWhState}
            onChange={(value) => handleChange("payrollWhState", value)}
            error={errors.payrollWhState}
            options={suiState}
          />
        </div>
        <div>
          <FormFieldSet
            type="checkbox"
            title="Multiple jobs or spouse works"
            values={formData.multipleJobs || []}
            onChange={(value) => handleChange("multipleJobs", value)}
            multiple
            error={errors.multipleJobs}
            size={"md"}
            options={[
              {
                label: "",
                value: "1",
              },
            ]}
          />
        </div>
        <div>
          <FormFieldSet
            type="text"
            title="Claim Dependent and Other Credits ($)"
            placeholder="Select Claim Dependent and Other Credits"
            value={formData.claimDependent}
            onChange={(value) => handleChange("claimDependent", value)}
            error={errors.claimDependent}
          />
        </div>
        <div>
          <FormFieldSet
            type="datepicker"
            title="Effective Date"
            placeholder="Select Effective Date"
            value={formData.effectiveDate}
            onChange={(value) => handleChange("effectiveDate", value)}
            error={errors.effectiveDate}
            showDropdown={false}
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            title="Status"
            placeholder="Select Status"
            value={formData.status}
            onChange={(value) => handleChange("status", value)}
            error={errors.status}
            options={RecordStatus}
          />
        </div>
      </div>
      <div className="mt-4 mb-1">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title="Attachments" tag="h6" />
            </div>
          }
        />
      </div>
      <Divider />
      {/* <div className="grid grid-cols-3 gap-x-6 gap-y-6 py-6"> */}
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-4 py-6">
        <FormFieldSet
          type="text"
          title="Other Income Amount ($)"
          placeholder="Enter Other Income Amount ($)"
          value={formData.otherIncomeAmount}
          onChange={(value) => handleChange("otherIncomeAmount", value)}
          error={errors.otherIncomeAmount}
        />
        <FormFieldSet
          type="text"
          title="Deductions Amount ($)"
          placeholder="Enter Deductions Amount ($)"
          value={formData.deductionsAmount}
          onChange={(value) => handleChange("deductionsAmount", value)}
          error={errors.deductionsAmount}
        />
        <FormFieldSet
          type="text"
          title="Extra Withholding Amount ($)"
          placeholder="Enter Extra Withholding Amount ($)"
          value={formData.extraWithholdingAmount}
          onChange={(value) => handleChange("extraWithholdingAmount", value)}
          error={errors.extraWithholdingAmount}
        />

        <FormFieldSet
          type="checkbox"
          title="Exempt from withholding"
          values={formData.exemptFromwithholding || []}
          onChange={(value) => handleChange("exemptFromwithholding", value)}
          error={errors.exemptFromwithholding}
          options={[
            {
              label: "",
              value: "1",
            },
          ]}
          multiple
        />
        <FormFieldSet
          type="checkbox"
          title="Is this employee exempt from Federal taxes ?"
          values={formData.employeeExemptFromFederalTaxes || []}
          onChange={(value) =>
            handleChange("employeeExemptFromFederalTaxes", value)
          }
          multiple
          error={errors.employeeExemptFromFederalTaxes}
          options={[
            {
              label: "",
              value: "1",
            },
          ]}
        />
        <FormFieldSet
          type="file"
          title="Attachments"
          placeholder="Choose Files"
          value={formData.attachments}
          multiple
          onChange={(value) => handleChange("attachments", value)}
          error={errors.attachments}
        />
        <FormFieldSet
          type="textArea"
          title="Notes"
          placeholder="Enter"
          value={formData.notes}
          onChange={(value) => handleChange("notes", value)}
          error={errors.notes}
        />
      </div>
      <div className="flex gap-4 justify-end mb-3">
        <Button
          title={"cancel"}
          variant="outlined"
          onClick={handleModalClose}
        />
        <Button title={"Save"} onClick={handleSaveW4Form} />
      </div>
    </Modal>
  );
};

export default W4FormModal;
